

export enum OperationCategoryEnum {
    CUTTING = 'C',
    SEWING = 'S',
    WASHING = 'W',
    FINISHING = 'F',
    PACKING = 'P'
}

export const OperationCategoryDisplayValues = {
    C : 'CUTTING',
    S: 'SEWING',
    W: 'WASHING',
    F: 'FINISHING',
    P: 'PACKING'
}